module.exports = __webpack_public_path__ + "img/city2-s.cdf0ae13.png";